import { AxiosResponse } from 'axios';

export interface TransactionListPagination {
  total: number;
  size: number;
  limit: number;
  start: number;
  links: Links;
}

export interface TransactionListBody {
  data: TransactionList[];
  pagination: TransactionListPagination;
  status: {
    code: number;
    messages: string[];
  };
}

export interface TransactionList {
  amount: string;
  child: Child;
  createdAt: string;
  id: string;
  merchantName: string;
  mid: string;
  payerName?: string;
  ref1: string;
  sourceOfFund?: string;
  status: string;
  transactionId: string;
  tid: string;
  qrType: TransactionQRType;
}

export interface Child {
  status: string | null;
  type: string | null;
}

interface Links {
  prev: null | string;
  self: null | string;
  next: null | string;
}

export type TransactionsListResponse = AxiosResponse<TransactionListBody>;

export const TransactionQRType = ['StaticQR', 'DynamicQR'] as const;
// eslint-disable-next-line no-redeclare
export type TransactionQRType = typeof TransactionQRType[number];

export const qrCodeTypesLabelMap: Record<string, string> = {
  StaticQR: 'static_qr',
  DynamicQR: 'dynamic_qr',
};
